import React, { useEffect, useState } from "react";
import { useFormik, FormikProvider, FieldArray } from "formik"; // Import FormikProvider and FieldArray
import * as yup from "yup";
import {
  Container,
  TextField,
  Button,
  Typography,
  Avatar,
  Box,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  IconButton,
  MenuItem,
  Snackbar,
  Alert,
  Divider,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  useTheme,
  useMediaQuery,
  Card,
  DialogContentText, // Added for visual separation
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveIcon from "@mui/icons-material/Save";
import styles from "./ScholarshipApplicationCreate.module.scss";
import CustomStepIcon from "../../../components/CommonComponent/CustomStepIcon/CustomStepIcon";
import CustomConnector from "../../../components/CommonComponent/CustomStepIcon/CustomConnector";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import placeholderImg from "../../../assets/images/nofile.jpg";
import AuditLog from "../../../components/AuditLog/AuditLog";
import { auditLogs } from "../../../data/auditLogData";
import { RegionArray } from "../../../data/region";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  applicantData,
  Durations,
  Frequencies,
  KnowApplicationData,
  occupationOptions,
  qualificationOptions,
  Semesters,
} from "../../../data/alldata";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  achievementItemSchema,
  bankDetailsSchema,
  completedEducationItemSchema,
  familyDetailsSchema,
  overallValidationSchema,
  personalInfoSchema,
  presentEducationSchema,
  scholarshipPurposeSchema,
  uploadedDocumentItemSchema,
} from "../../../forms/scholarshipValidationNew";
import { InitialValues } from "../../../types/formTypes";
import {
  configBlobToken,
  configNotCustomToken,
  GetUrl,
  PatchUrl,
  PostUrl,
} from "../../../api/endpointConfig";
// import { usePost } from "../../services/hooks/Method";
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { useGet } from "../../../services/hooks/useGet";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  ApplicantForm,
  ApplicantInterface,
  FilesInterface,
  requiredPersonalInfoFields,
} from "../../../types/types";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { title } from "process";
import axios from "axios";
import { API_URL, API_VERSION, BLOB_API } from "../../../config/config";
import { isEqual, values } from "lodash";
import { useLoader } from "../../../Loader/LoaderContext";
import { getSecureBlobUrl } from "../../../utils/blobUploader";
import { ToastService } from "../../../utils/toastService";

const steps = [
  "Personal Info",
  "Completed Education",
  "Present Education",
  "Achievements",
  "Family Details",
  "Scholarship Purpose",
  "Bank Details",
  // "Documents",
];
interface FileDetails {
  filename: string;
  imagepath?: string;
}
const ScholarshipApplicationCreate: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [applicationID, setApplicationID] = useState<number | null>(null);
  const [appMobileNo, setAppMobileNo] = useState<string | null>(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [districtOptions, setDistrictOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [draftStateUpdate, setDraftStateUpdate] = useState(false);
  const [fileType, setFileType] = useState<string>("");
  const [applicationStatus, setApplicationStatus] = useState<string>("");

  const [mainData, setMainData] = useState<ApplicantForm[]>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();
  useEffect(() => {
    const appid = localStorage.getItem("applicationID");
    const appStatus = localStorage.getItem("applicationStatus");
    const appMobile = localStorage.getItem("mobileNumber");
    if (appid) {
      setApplicationID(Number(appid));
    }
    if (appStatus) {
      setApplicationStatus(appStatus);
    }
    if (appMobile) {
      setAppMobileNo(appMobile);
    }
  }, []);

  const handleSuccessModalClose = () => {
    setSuccessModalOpen(false);
    navigate(`/landing`);
  };

  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: overallValidationSchema,
    onSubmit: (values) => {
      console.log("Form submitted:", values);
      handleFinalSubmit();
    },
  });
 
  const {
  control,
  handleSubmit,
  trigger, // For manual validation
  formState: { errors, isValid }
} = useForm<typeof InitialValues>({
  resolver: yupResolver(overallValidationSchema as any),
  defaultValues: InitialValues,
  mode: 'onTouched'
});
const onSubmit = (data:any) => {
  console.log(data)
};
  const hasAllKeys = (obj: any, requiredKeys: string[]) => {
    return requiredKeys.every((key) => {
      const val = obj[key];
      return val !== undefined && val !== null && val !== "";
    });
  };
  const isEmptyValue = (value: any): boolean => {
    if (value === null || value === undefined) return true;
    if (typeof value === "string" && value.trim() === "") return true;
    if (Array.isArray(value) && value.length === 0) return true;
    if (typeof value === "object" && !Array.isArray(value)) {
      return Object.keys(value).length === 0;
    }
    return false;
  };

  const isEqualDeep = (obj1: any, obj2: any): boolean => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };
  const extractDeltaObject = (current: any, previous: any): any => {
    const delta: any = {};

    for (const key in current) {
      const currentValue = current[key];
      const previousValue = previous?.[key];

      if (isEmptyValue(currentValue)) continue;

      const isChanged = !isEqualDeep(currentValue, previousValue);

      if (isChanged) {
        delta[key] = currentValue;
      }
    }

    return delta;
  };
  const applicationAllFieldsData = () => {
    const appid = localStorage.getItem("applicationID");
    const objValues = formik.values;
    const titleList = [
      "Secondary Education",
      "Higher Secondary Education",
      "Graduation",
      "Post Graduation",
    ];
    const datamap = objValues.completedEducation
      .filter((item) =>
        hasAllKeys(item, [
          "nameSchoolCollege",
          "schoolCollegeAddress",
          "nameOfUniversity",
          "course",
          "marksObtainedCGPA",
          "yearOfPassing",
          "principalName",
          "principalContactNumber",
          "uploadMarksheet",
        ])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          title: titleList[index] || item.course,
          institution: item.nameSchoolCollege,
          address: item.schoolCollegeAddress,
          university_name: item.nameOfUniversity,
          stream: item.course,
          total_marks_cgpa: item.marksObtainedCGPA,
          year_of_passing: item.yearOfPassing,
          principal_name: item.principalName,
          principal_ph: item.principalContactNumber,
          marksheet_url: item.fileName,
        };
      });
    const datamapSibling = objValues.familyDetails.siblings
      .filter((item) =>
        hasAllKeys(item, ["name", "relationship", "qualification"])
      )
      .map((item) => {
        const base = {
          id: item.id ? item.id : 0,
          sibling_name: item.name,
          relationship: item.relationship,
          occupation: item.qualification,
          sister_husband_name: item.sisterHusbandName,
          sister_husband_occupation: item.sisterHusbandOccupation,
        };

        // Conditionally enrich with sister's husband details
        if (item.relationship === "sister") {
          return {
            ...base,
            sister_husband_name: item.sisterHusbandName,
            sister_husband_occupation: item.sisterHusbandOccupation,
          };
        }

        return base;
      });
    const datamapother = objValues.scholarshipPurpose.otherScholarships
      .filter((item) =>
        hasAllKeys(item, ["scholarshipsName", "scholarshipsAmount"])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          scholarship_name: item.scholarshipsName,
          scholarship_amount: item.scholarshipsAmount,
        };
      });
    const datamapachievements = objValues.achievementsInfo
      .filter((item) => hasAllKeys(item, ["fileName"]))
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          achievement: item.docName,
          supporting_doc_url: item.fileName,
        };
      });
    const bankTitleList = ["Student", "Father", "Guardian", "College/School"];
    const banckInfo = objValues.bankDetails
      .filter((item) =>
        hasAllKeys(item, [
          "bankName",
          "accountHolderName",
          "accountNumber",
          "ifscCode",
          "branchName",
        ])
      )
      .map((item, index) => {
        return {
          id: item.id ? item.id : 0,
          title: bankTitleList[index],
          bank_name: item.bankName,
          account_holder_name: item.accountHolderName,
          account_no: item.accountNumber,
          IFSC_no: item.ifscCode,
          branch: item.branchName,
        };
      });

    const presentEducation = [objValues.presentEducation]
      .filter((item) =>
        hasAllKeys(item, [
          "nameSchoolorCollege",
          "schoolCollegeAddress",
          "nameOfUniversity",
          "course",
          "yearOfAdmission",
          "currentSemester",
          "courseDuration",
          "principalName",
          "principalContactNumber",
          "courseFees",
          "paymentFrequency",
          "totalFeesPaid",
        ])
      )
      .map((item) => {
        return {
          id: item.id ? item.id : 0,
          institution: item.nameSchoolorCollege,
          address: item.schoolCollegeAddress,
          university_name: item.nameOfUniversity,
          stream: item.course,
          Year_of_Admission: item.yearOfAdmission,
          Current_sem: item.currentSemester,
          Course_dur: item.courseDuration,
          principal_name: item.principalName,
          principal_ph: item.principalContactNumber,
          Course_fee: item.courseFees,
          Frequency_of_payment: item.paymentFrequency,
          Fees_Already_paid: item.totalFeesPaid,
        };
      });
    const personalInfo = [objValues.personalInfo]
      .filter((item) =>
        hasAllKeys(item, [
          "firstName",
          "lastName",
          "email",
          "mobileNumber",
          "dateOfBirth",
          "permanentHomeAddress",
          "city",
          "zipcode",
          "state",
          "district",
          "profilePhoto",
          "gender",
        ])
      )
      .map((item) => {
        return {
          first_name: item.firstName,
          last_name: item.lastName,
          email: item.email,
          phone: item.mobileNumber,
          dob: item.dateOfBirth,
          home_address: item.permanentHomeAddress,
          city: item.city,
          zipcode: item.zipcode,
          state: item.state,
          district: item.district,
          photo_url: item.profilePhotoName,
          facebook_url: item.socialMediaHandleFB || null,
          instagram_url: item.socialMediaHandleInstagram || null,
          linkedin_url: item.socialMediaHandleLinkedIn || null,
          gender: item.gender,
        };
      });
    const familyDetails = [objValues.familyDetails]
      .filter((item) =>
        hasAllKeys(item, [
          "fathersName",
          "mothersName",
          "guardiansName",
          "fathersOccupation",
          "mothersOccupation",
          "familyIncome",
          "contactNumber",
        ])
      )
      .map((item) => {
        return {
          id: item.id ? item.id : 0,
          father_name: item.fathersName,
          mother_name: item.mothersName,
          guardian_name: item.guardiansName,
          father_occupation: item.fathersOccupation,
          mother_occupation: item.mothersOccupation,
          monthly_familiy_income: item.familyIncome,
          guardian_ph_number: item.contactNumber,
          siblings: datamapSibling,
        };
      });
    const scholarshipPurpose = [objValues.scholarshipPurpose]
      .filter((item) =>
        hasAllKeys(item, ["knowApplication", "purposeExplanation"])
      )
      .map((item) => {
        return {
          source_of_infomation: item.knowApplication,
          scholarship_purpose: item.purposeExplanation,
          other_scholarships: datamapother,
        };
      });
    const obj = {
      application_id: applicationID || appid,
      personal_info: personalInfo[0],
      completedEducation: datamap,
      presentEducation: presentEducation,
      achievements: datamapachievements,
      family_details: familyDetails[0],
      scholarship_purpose: scholarshipPurpose[0],
      bank_details: banckInfo,
      // additional_documents: addiDocs,
    };
    return obj;
  };
  const deltaPayload = extractDeltaObject(
    applicationAllFieldsData(),
    mainData[0]
  );
  const handleProfilePhotoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleFileUpload(
      event,
      "personalInfo.profilePhoto",
      "personalInfo.profilePhotoName"
    );
  };

  const handleMarksheetUploadChange = async (
    files: FileList | null,
    index: number
  ) => {
    if (!files || files.length === 0) return;
    const uploadedBlobUrls: any[] = [];
    for (const file of Array.from(files)) {
      try {
        const extension = file.name.split(".").pop()?.toLowerCase() || "pdf";
        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        const { data: sastokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
        );

        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const putRes = await axios.put(uploadUrl, buffer, configBlobToken);

        if (![200, 201].includes(putRes.status)) {
          console.warn(`Upload failed for ${file.name}`);
          continue;
        }

        const { data: accessTokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
        );

        const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
        const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;
        uploadedBlobUrls.push({
          blobFileUrl: blobFileUrl,
          secureBlobUrl: secureBlobUrl,
          filename: sastokenInfo.filename,
          fileType: file.type,
        });
        ToastService.success("File upload successfully!");
      } catch (err) {
        console.error("Upload failed:", err);
      }
    }

    // Step 3: Push to Formik – store the first uploaded URL as a string (or null)
    const updatedEducation = [...formik.values.completedEducation];
    updatedEducation[index] = {
      ...updatedEducation[index],
      uploadMarksheet:
        uploadedBlobUrls.length > 0
          ? uploadedBlobUrls[0].blobFileUrl
          : (null as any), // Store a single string URL or null
      fileName: uploadedBlobUrls[0].filename,
      uploadMarksheetPreview: uploadedBlobUrls[0].secureBlobUrl,
      fileType: uploadedBlobUrls[0].fileType,
    };
    formik.setFieldValue("completedEducation", updatedEducation);
  };

 
  const handleDocumentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const files: FileList | null = event.target.files;
    if (!files || files.length === 0) return;

    const uploadedBlobUrls: any[] = [];

    for (const file of Array.from(files)) {
      try {
        const extension = file.name.split(".").pop()?.toLowerCase() || "pdf";

        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        const { data: sastokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
        );

        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const putRes = await axios.put(uploadUrl, buffer, configBlobToken);

        if (![200, 201].includes(putRes.status)) {
          console.warn(`Upload failed for ${file.name}`);
          continue;
        }

        const { data: accessTokenInfo } = await axios.get(
          `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
        );

        const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
        const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;

        uploadedBlobUrls.push({
          blobFileUrl: blobFileUrl,
          secureBlobUrl: secureBlobUrl,
          filename: sastokenInfo.filename,
          fileType: file.type,
        });
      } catch (err) {
        console.error("Upload failed:", err);
      }
    }

    // Step 3: Push to Formik – store the first uploaded URL as a string (or null)
    const updatedEducation = [...formik.values.achievementsInfo];
    updatedEducation[index] = {
      ...updatedEducation[index],
      file:
        uploadedBlobUrls.length > 0
          ? uploadedBlobUrls[0].blobFileUrl
          : (null as any), // Store a single string URL or null
      fileName: uploadedBlobUrls[0].filename,
      uploadPreview: uploadedBlobUrls[0].secureBlobUrl,
      fileType: uploadedBlobUrls[0].fileType,
    };
    formik.setFieldValue("achievementsInfo", updatedEducation);
  };
  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    formikFieldPath: string,
    filePathName: string
  ) => {
    const file = event.currentTarget.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    setFileType(fileExtension || "");

    try {
      const { data: sastokenInfo } = await axios.get(
        `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${fileExtension}`
      );

      const reader = new FileReader();

      reader.onloadend = async () => {
        const base64 = (reader.result as string).split(",")[1];
        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
        const imagePath = `${BLOB_API}/documents/${sastokenInfo.filename}`;
        const response = await axios.put(uploadUrl, buffer, configBlobToken);
        if (response.status === 200 || response.status === 201) {
          const { data: accessTokenInfo } = await axios.get(
            `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
          );
          const finalUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
          formik.setFieldValue(formikFieldPath, finalUrl);
          formik.setFieldValue(filePathName, sastokenInfo.filename);
        } else {
          console.error("Upload failed:", response.statusText);
        }
      };

      reader.readAsDataURL(file);
      ToastService.success("File upload successfully!");
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Axios error:", error.response);
      } else {
        console.error("Upload failed:", error);
      }
    }
  };
  const handleNext = async () => {
    let currentStepSchema;
    let isValid = false;
    switch (activeStep) {
      case 0:
        isValid = await trigger('personalInfo');
        break;
      case 1:
        isValid =  await trigger('completedEducation');
        break;
      case 2:
        isValid = await trigger('presentEducation');
        break;
      case 3:
        isValid = await trigger('achievementsInfo');
        break;
      case 4:
        isValid = await trigger('familyDetails');
        break;
      case 5:
        isValid = await trigger('scholarshipPurpose');
        break;
      case 6:
        isValid = await trigger('bankDetails');
        break;
      // case 7:
      //   currentStepSchema = yup.array().of(uploadedDocumentItemSchema);

      // break;
      // default:
      //   isValid = yup.object();
    }

     
  };

  // Define the function outside handleNext

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSnackbarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleStateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedState = e.target.value;
    const selectedStateData = RegionArray.states.find(
      (state) => state.name === selectedState
    );
    setDistrictOptions(selectedStateData?.districts || []);

    formik.setFieldValue("personalInfo.state", selectedState);
    formik.setFieldValue("personalInfo.district", "");
  };

  // --- Step Content Rendering ---
  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <>
            <Box className={styles.formContent}>
              {/* Left Column: Passport Photo */}
              <Box className={styles.passportPhotoColumn}>
                <Box className={styles.passportPhotoSection}>
                  <Avatar
                    alt="Passport Size Photo"
                    src={
                      typeof formik.values.personalInfo.profilePhoto ===
                      "string"
                        ? formik.values.personalInfo.profilePhoto
                        : formik.values.personalInfo.profilePhoto
                        ? URL.createObjectURL(
                            formik.values.personalInfo.profilePhoto
                          )
                        : placeholderImg
                    }
                    className={styles.avatar}
                  />
                  <Typography
                    variant="subtitle1"
                    className={styles.passportPhotoText}
                  >
                    Passport Size Photo
                  </Typography>
                  <Button
                    variant="contained"
                    component="label"
                    className={styles.browseButton}
                  >
                    Browse
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleProfilePhotoChange}
                    />
                  </Button>
                  {formik.touched.personalInfo?.profilePhoto &&
                    Boolean(formik.errors.personalInfo?.profilePhoto) && (
                      <Typography color="error" variant="caption">
                        {formik.errors.personalInfo?.profilePhoto as string}
                      </Typography>
                    )}
                </Box>
              </Box>

              {/* Right Column: Personal Info Fields */}
              <Box className={styles.personalInfoColumn}>
                <Typography
                  variant="h6"
                  className={styles.sectionTitle}
                  marginBottom={3}
                  display={"flex"}
                  justifyContent={"center"}
                >
                  <span>Personal Info</span>
                </Typography>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.firstName"
                    name="personalInfo.firstName"
                    label="First Name *"
                    value={formik.values.personalInfo.firstName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.firstName &&
                      Boolean(formik.errors.personalInfo?.firstName)
                    }
                    helperText={
                      formik.touched.personalInfo?.firstName &&
                      formik.errors.personalInfo?.firstName
                    }
                    className={styles.textFourField}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.lastName"
                    name="personalInfo.lastName"
                    label="Last Name *"
                    value={formik.values.personalInfo.lastName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.lastName &&
                      Boolean(formik.errors.personalInfo?.lastName)
                    }
                    helperText={
                      formik.touched.personalInfo?.lastName &&
                      formik.errors.personalInfo?.lastName
                    }
                    className={styles.textFourField}
                  />
                  <TextField
                    fullWidth
                    select
                    id="personalInfo.gender"
                    name="personalInfo.gender"
                    label="Gender *"
                    value={formik.values.personalInfo.gender}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.gender &&
                      Boolean(formik.errors.personalInfo?.gender)
                    }
                    helperText={
                      formik.touched.personalInfo?.gender &&
                      formik.errors.personalInfo?.gender
                    }
                    className={styles.textFourField}
                  >
                    <MenuItem value="">Select Gender</MenuItem>
                    <MenuItem value="male">Male</MenuItem>
                    <MenuItem value="female">Female</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </TextField>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        label="Date of Birth *"
                        views={["year", "month", "day"]}
                        value={
                          formik.values.personalInfo.dateOfBirth
                            ? dayjs(
                                formik.values.personalInfo.dateOfBirth,
                                "YYYYMMDD"
                              )
                            : null
                        }
                        onChange={(date) => {
                          formik.setFieldValue(
                            `personalInfo.dateOfBirth`,
                            date && date.isValid()
                              ? date.format("YYYY-MM-DD")
                              : ""
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.personalInfo?.dateOfBirth &&
                              typeof formik.errors.personalInfo !== "string" &&
                              Boolean(
                                (formik.errors.personalInfo as any)?.dateOfBirth
                              ),
                            helperText:
                              formik.touched.personalInfo?.dateOfBirth &&
                              typeof formik.errors.personalInfo !== "string" &&
                              (formik.errors.personalInfo as any)?.dateOfBirth,
                            InputLabelProps: { shrink: true },
                            className: styles.textFourField,
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.email"
                    name="personalInfo.email"
                    label="Email *"
                    value={formik.values.personalInfo.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.email &&
                      Boolean(formik.errors.personalInfo?.email)
                    }
                    helperText={
                      formik.touched.personalInfo?.email &&
                      formik.errors.personalInfo?.email
                    }
                    className={styles.textThreeField}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.mobileNumber"
                    name="personalInfo.mobileNumber"
                    label="Mobile Number *"
                    type="number"
                    value={formik.values.personalInfo.mobileNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.mobileNumber &&
                      Boolean(formik.errors.personalInfo?.mobileNumber)
                    }
                    helperText={
                      formik.touched.personalInfo?.mobileNumber &&
                      formik.errors.personalInfo?.mobileNumber
                    }
                    className={styles.textThreeField}
                  />
                </Box>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleFB"
                    name="personalInfo.socialMediaHandleFB"
                    label="Facebook Handle"
                    value={formik.values.personalInfo.socialMediaHandleFB}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.socialMediaHandleFB &&
                      Boolean(formik.errors.personalInfo?.socialMediaHandleFB)
                    }
                    helperText={
                      formik.touched.personalInfo?.socialMediaHandleFB &&
                      formik.errors.personalInfo?.socialMediaHandleFB
                    }
                    className={styles.textThreeField}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleInstagram"
                    name="personalInfo.socialMediaHandleInstagram"
                    label="Instagram Handle"
                    value={
                      formik.values.personalInfo.socialMediaHandleInstagram
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.socialMediaHandleInstagram &&
                      Boolean(
                        formik.errors.personalInfo?.socialMediaHandleInstagram
                      )
                    }
                    helperText={
                      formik.touched.personalInfo?.socialMediaHandleInstagram &&
                      formik.errors.personalInfo?.socialMediaHandleInstagram
                    }
                    className={styles.textThreeField}
                  />
                  <TextField
                    fullWidth
                    id="personalInfo.socialMediaHandleLinkedIn"
                    name="personalInfo.socialMediaHandleLinkedIn"
                    label="LinkedIn Handle"
                    value={formik.values.personalInfo.socialMediaHandleLinkedIn}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.socialMediaHandleLinkedIn &&
                      Boolean(
                        formik.errors.personalInfo?.socialMediaHandleLinkedIn
                      )
                    }
                    helperText={
                      formik.touched.personalInfo?.socialMediaHandleLinkedIn &&
                      formik.errors.personalInfo?.socialMediaHandleLinkedIn
                    }
                    className={styles.textThreeField}
                  />
                </Box>
                <Typography
                  variant="h6"
                  className={styles.sectionTitle}
                  marginBottom={3}
                  marginTop={3}
                  display={"flex"}
                  justifyContent={"center"}
                >
                  <span>Permanent Home Address</span>
                </Typography>
                <Box className={styles.fieldRow}>
                  <TextField
                    fullWidth
                    id="personalInfo.permanentHomeAddress"
                    name="personalInfo.permanentHomeAddress"
                    label="Permanent home address *"
                    value={formik.values.personalInfo.permanentHomeAddress}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.personalInfo?.permanentHomeAddress &&
                      Boolean(formik.errors.personalInfo?.permanentHomeAddress)
                    }
                    helperText={
                      formik.touched.personalInfo?.permanentHomeAddress &&
                      formik.errors.personalInfo?.permanentHomeAddress
                    }
                    className={styles.textThreeField}
                    multiline
                    rows={4}
                  />
                  <Box className={styles.textThreeField}>
                    <Box className={styles.fieldRow}>
                      <TextField
                        fullWidth
                        id="personalInfo.city"
                        name="personalInfo.city"
                        label="City *"
                        value={formik.values.personalInfo.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.personalInfo?.city &&
                          Boolean(formik.errors.personalInfo?.city)
                        }
                        helperText={
                          formik.touched.personalInfo?.city &&
                          formik.errors.personalInfo?.city
                        }
                        className={styles.textField}
                      />

                      <TextField
                        fullWidth
                        select
                        id="personalInfo.state"
                        name="personalInfo.state"
                        label="State *"
                        value={formik.values.personalInfo.state}
                        onChange={handleStateChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.personalInfo?.state &&
                          Boolean(formik.errors.personalInfo?.state)
                        }
                        helperText={
                          formik.touched.personalInfo?.state &&
                          formik.errors.personalInfo?.state
                        }
                        className={styles.textField}
                      >
                        <MenuItem value="">Select State</MenuItem>
                        {RegionArray.states.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        select
                        id="personalInfo.district"
                        name="personalInfo.district"
                        label="District *"
                        value={formik.values.personalInfo.district}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.personalInfo?.district &&
                          Boolean(formik.errors.personalInfo?.district)
                        }
                        helperText={
                          formik.touched.personalInfo?.district &&
                          formik.errors.personalInfo?.district
                        }
                        className={styles.textField}
                      >
                        <MenuItem value="">Select District</MenuItem>
                        {districtOptions.map((district, index) => (
                          <MenuItem key={index} value={district.name}>
                            {district.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        id="personalInfo.zipcode"
                        name="personalInfo.zipcode"
                        label="Zipcode *"
                        value={formik.values.personalInfo.zipcode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.personalInfo?.zipcode &&
                          Boolean(formik.errors.personalInfo?.zipcode)
                        }
                        helperText={
                          formik.touched.personalInfo?.zipcode &&
                          formik.errors.personalInfo?.zipcode
                        }
                        className={styles.textField}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        );

      case 1: // Completed Education
        return (
          <Box className={styles.educationSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Completed Education Details</span>
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="completedEducation">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.completedEducation.map(
                      (education, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              {education.title}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box className={styles.fieldRow}>
                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].nameSchoolCollege`}
                                name={`completedEducation[${index}].nameSchoolCollege`}
                                label="Name of School/College *"
                                value={education.nameSchoolCollege}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.completedEducation?.[index]
                                    ?.nameSchoolCollege &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.nameSchoolCollege
                                  )
                                }
                                helperText={
                                  formik.touched.completedEducation?.[index]
                                    ?.nameSchoolCollege &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.nameSchoolCollege
                                }
                                className={styles.textFourField}
                                multiline
                                rows={4}
                              />
                              <Box className={styles.textField}>
                                <Box className={styles.fieldRow}>
                                  <TextField
                                    fullWidth
                                    id={`completedEducation[${index}].schoolCollegeAddress`}
                                    name={`completedEducation[${index}].schoolCollegeAddress`}
                                    label="School / College Address *"
                                    value={education.schoolCollegeAddress}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched.completedEducation?.[index]
                                        ?.schoolCollegeAddress &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.schoolCollegeAddress
                                      )
                                    }
                                    helperText={
                                      formik.touched.completedEducation?.[index]
                                        ?.schoolCollegeAddress &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.schoolCollegeAddress
                                    }
                                  />

                                  <TextField
                                    fullWidth
                                    id={`completedEducation[${index}].nameOfUniversity`}
                                    name={`completedEducation[${index}].nameOfUniversity`}
                                    label="Name of Board/University *"
                                    value={education.nameOfUniversity}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched.completedEducation?.[index]
                                        ?.nameOfUniversity &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.nameOfUniversity
                                      )
                                    }
                                    helperText={
                                      formik.touched.completedEducation?.[index]
                                        ?.nameOfUniversity &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.nameOfUniversity
                                    }
                                    className={styles.textFourField}
                                  />
                                  <TextField
                                    fullWidth
                                    id={`completedEducation[${index}].course`}
                                    name={`completedEducation[${index}].course`}
                                    label="Standard/Stream *"
                                    value={education.course}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      // Set title to the same value as course
                                      formik.setFieldValue(
                                        `completedEducation[${index}].title`,
                                        e.target.value
                                      );
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched.completedEducation?.[index]
                                        ?.course &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.completedEducation?.[
                                            index
                                          ] as any
                                        )?.course
                                      )
                                    }
                                    helperText={
                                      formik.touched.completedEducation?.[index]
                                        ?.course &&
                                      typeof formik.errors.completedEducation?.[
                                        index
                                      ] !== "string" &&
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.course
                                    }
                                    className={styles.textFourField}
                                  />
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DemoContainer components={["DatePicker"]}>
                                      <DatePicker
                                        label="Year of Passing *"
                                        views={["year"]}
                                        value={
                                          education.yearOfPassing
                                            ? dayjs(
                                                education.yearOfPassing,
                                                "YYYY"
                                              )
                                            : null
                                        }
                                        onChange={(date) => {
                                          formik.setFieldValue(
                                            `completedEducation[${index}].yearOfPassing`,
                                            date && date.isValid()
                                              ? date.format("YYYY")
                                              : ""
                                          );
                                        }}
                                        slotProps={{
                                          textField: {
                                            fullWidth: true,
                                            error:
                                              formik.touched
                                                .completedEducation?.[index]
                                                ?.yearOfPassing &&
                                              typeof formik.errors
                                                .completedEducation?.[index] !==
                                                "string" &&
                                              Boolean(
                                                (
                                                  formik.errors
                                                    .completedEducation?.[
                                                    index
                                                  ] as any
                                                )?.yearOfPassing
                                              ),
                                            helperText:
                                              formik.touched
                                                .completedEducation?.[index]
                                                ?.yearOfPassing &&
                                              typeof formik.errors
                                                .completedEducation?.[index] !==
                                                "string" &&
                                              (
                                                formik.errors
                                                  .completedEducation?.[
                                                  index
                                                ] as any
                                              )?.yearOfPassing,
                                            InputLabelProps: { shrink: true },
                                            className: styles.textFourField,
                                          },
                                        }}
                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </Box>
                              </Box>
                            </Box>
                            <Box className={styles.fieldRow}>
                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].marksObtainedCGPA`}
                                name={`completedEducation[${index}].marksObtainedCGPA`}
                                label="Marks Obtained/CGPA *"
                                type="number"
                                value={education.marksObtainedCGPA}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.completedEducation?.[index]
                                    ?.marksObtainedCGPA &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.marksObtainedCGPA
                                  )
                                }
                                helperText={
                                  formik.touched.completedEducation?.[index]
                                    ?.marksObtainedCGPA &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.marksObtainedCGPA
                                }
                                className={styles.textFourField}
                              />
                               

                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].principalName`}
                                name={`completedEducation[${index}].principalName`}
                                label="Principal's Name *"
                                value={education.principalName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.completedEducation?.[index]
                                    ?.principalName &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.principalName
                                  )
                                }
                                helperText={
                                  formik.touched.completedEducation?.[index]
                                    ?.principalName &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.principalName
                                }
                                className={styles.textFourField}
                              />
                              <TextField
                                fullWidth
                                id={`completedEducation[${index}].principalContactNumber`}
                                name={`completedEducation[${index}].principalContactNumber`}
                                label="Principal's Contact Number *"
                                value={education.principalContactNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.completedEducation?.[index]
                                    ?.principalContactNumber &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  Boolean(
                                    (
                                      formik.errors.completedEducation?.[
                                        index
                                      ] as any
                                    )?.principalContactNumber
                                  )
                                }
                                helperText={
                                  formik.touched.completedEducation?.[index]
                                    ?.principalContactNumber &&
                                  typeof formik.errors.completedEducation?.[
                                    index
                                  ] !== "string" &&
                                  (
                                    formik.errors.completedEducation?.[
                                      index
                                    ] as any
                                  )?.principalContactNumber
                                }
                                className={styles.textFourField}
                              />
                            </Box>
                            <Box className={styles.fieldRow}>
                              <Box className={styles.fileUploadField}>
                                <Typography
                                  variant="subtitle2"
                                  sx={{ mb: 0 }}
                                  paddingBottom={"0.25rem"}
                                >
                                  Upload Marksheet *
                                </Typography>
                                <Box display={"flex"} alignItems={"center"}>
                                  <Button
                                    variant="contained"
                                    component="label"
                                    className="commonBtn"
                                    sx={{ flex: "none", marginRight: "1rem" }}
                                  >
                                    Choose File
                                    <input
                                      type="file"
                                      hidden
                                      onChange={(e) =>
                                        handleMarksheetUploadChange(
                                          e.target.files,
                                          index
                                        )
                                      }
                                    />
                                  </Button>
                                  <Typography variant="body2">
                                    {education.uploadMarksheet
                                      ? education.fileName
                                      : "No file chosen"}
                                  </Typography>
                                  {formik.touched.completedEducation?.[index]
                                    ?.uploadMarksheet &&
                                    typeof formik.errors.completedEducation?.[
                                      index
                                    ] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.completedEducation?.[
                                          index
                                        ] as any
                                      )?.uploadMarksheet
                                    ) && (
                                      <Typography
                                        color="error"
                                        variant="caption"
                                      >
                                        {
                                          (
                                            formik.errors.completedEducation?.[
                                              index
                                            ] as any
                                          )?.uploadMarksheet as string
                                        }
                                      </Typography>
                                    )}
                                </Box>
                                {education.fileType === "application/pdf" ? (
                                  <>{education.fileName}</>
                                ) : (
                                  <>
                                    <Box mt={1}>
                                      <img
                                        src={
                                          typeof education.uploadMarksheetPreview ===
                                          "string"
                                            ? education.uploadMarksheetPreview
                                            : education.uploadMarksheetPreview
                                            ? URL.createObjectURL(
                                                education.uploadMarksheetPreview
                                              )
                                            : placeholderImg
                                        }
                                        alt="Preview"
                                        style={{
                                          maxHeight: 150,
                                          borderRadius: 8,
                                        }}
                                      />
                                    </Box>
                                  </>
                                )}

                                 
                              </Box>
                            </Box>
                            {formik.values.completedEducation.length > 1 && (
                              <Button
                                startIcon={<RemoveCircleOutlineIcon />}
                                color="error"
                                onClick={() => remove(index)}
                                className={styles.removeButton}
                              >
                                Remove
                              </Button>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        startIcon={<AddCircleOutlineIcon />}
                        variant="contained"
                        onClick={() =>
                          push({
                            id: 0,
                            title: "New Education",
                            nameSchoolCollege: "",
                            schoolCollegeAddress: "",
                            nameOfUniversity: "",
                            course: "",
                            marksObtainedCGPA: "",
                            yearOfPassing: "",
                            principalName: "",
                            principalContactNumber: "",
                            uploadMarksheet: null,
                          })
                        }
                        className={styles.commonBtn}
                      >
                        Add More Education
                      </Button>
                    </Box>
                    {formik.touched.completedEducation &&
                      typeof formik.errors.completedEducation === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.completedEducation}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 2: // Present Education
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Present Education Details</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={4}>
              Please provide your present course details for which you are
              applying for scholarship..
            </Typography>
            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="presentEducation.nameSchoolorCollege"
                name="presentEducation.nameSchoolorCollege"
                label="Name of School/College *"
                value={formik.values.presentEducation.nameSchoolorCollege}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.nameSchoolorCollege &&
                  Boolean(formik.errors.presentEducation?.nameSchoolorCollege)
                }
                helperText={
                  formik.touched.presentEducation?.nameSchoolorCollege &&
                  formik.errors.presentEducation?.nameSchoolorCollege
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="presentEducation.schoolCollegeAddress"
                name="presentEducation.schoolCollegeAddress"
                label="School/College Address *"
                value={formik.values.presentEducation.schoolCollegeAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.schoolCollegeAddress &&
                  Boolean(formik.errors.presentEducation?.schoolCollegeAddress)
                }
                helperText={
                  formik.touched.presentEducation?.schoolCollegeAddress &&
                  formik.errors.presentEducation?.schoolCollegeAddress
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="presentEducation.nameOfUniversity"
                name="presentEducation.nameOfUniversity"
                label="Name of Board/University *"
                value={formik.values.presentEducation.nameOfUniversity}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.nameOfUniversity &&
                  Boolean(formik.errors.presentEducation?.nameOfUniversity)
                }
                helperText={
                  formik.touched.presentEducation?.nameOfUniversity &&
                  formik.errors.presentEducation?.nameOfUniversity
                }
                className={styles.textFourField}
              />

              <TextField
                fullWidth
                id="presentEducation.course"
                name="presentEducation.course"
                label="Standard/Stream *"
                value={formik.values.presentEducation.course}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.course &&
                  Boolean(formik.errors.presentEducation?.course)
                }
                helperText={
                  formik.touched.presentEducation?.course &&
                  formik.errors.presentEducation?.course
                }
                className={styles.textFourField}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    label="Year of Admissions *"
                    views={["year"]}
                    value={
                      formik.values.presentEducation.yearOfAdmission
                        ? dayjs(
                            formik.values.presentEducation.yearOfAdmission,
                            "YYYY"
                          )
                        : null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `presentEducation.yearOfAdmission`,
                        date && date.isValid() ? date.format("YYYY") : ""
                      );
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error:
                          formik.touched.presentEducation?.yearOfAdmission &&
                          typeof formik.errors.presentEducation !== "string" &&
                          Boolean(
                            (formik.errors.presentEducation as any)
                              ?.yearOfAdmission
                          ),
                        helperText:
                          formik.touched.presentEducation?.yearOfAdmission &&
                          typeof formik.errors.presentEducation !== "string" &&
                          (formik.errors.presentEducation as any)
                            ?.yearOfAdmission,
                        InputLabelProps: { shrink: true },
                        className: styles.textFourField,
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <TextField
                fullWidth
                select
                id="presentEducation.currentSemester"
                name="presentEducation.currentSemester"
                label="Current Semester (if applicable) *"
                value={formik.values.presentEducation.currentSemester}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.currentSemester &&
                  Boolean(formik.errors.presentEducation?.currentSemester)
                }
                helperText={
                  formik.touched.presentEducation?.currentSemester &&
                  formik.errors.presentEducation?.currentSemester
                }
                className={styles.textFourField}
              >
                <MenuItem value="">Select Semester</MenuItem>
                {Semesters.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item} Semester
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                id="presentEducation.courseDuration"
                name="presentEducation.courseDuration"
                label="Course Duration *"
                value={formik.values.presentEducation.courseDuration}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.courseDuration &&
                  Boolean(formik.errors.presentEducation?.courseDuration)
                }
                helperText={
                  formik.touched.presentEducation?.courseDuration &&
                  formik.errors.presentEducation?.courseDuration
                }
                className={styles.textFourField}
              >
                <MenuItem value="">Select Course</MenuItem>
                {Durations.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                id="presentEducation.principalName"
                name="presentEducation.principalName"
                label="Principal's Name *"
                value={formik.values.presentEducation.principalName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.principalName &&
                  Boolean(formik.errors.presentEducation?.principalName)
                }
                helperText={
                  formik.touched.presentEducation?.principalName &&
                  formik.errors.presentEducation?.principalName
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="presentEducation.principalContactNumber"
                name="presentEducation.principalContactNumber"
                label="Principal's Contact Number *"
                value={formik.values.presentEducation.principalContactNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.principalContactNumber &&
                  Boolean(
                    formik.errors.presentEducation?.principalContactNumber
                  )
                }
                helperText={
                  formik.touched.presentEducation?.principalContactNumber &&
                  formik.errors.presentEducation?.principalContactNumber
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="presentEducation.courseFees"
                name="presentEducation.courseFees"
                label="Course Fees *"
                value={formik.values.presentEducation.courseFees}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.courseFees &&
                  Boolean(formik.errors.presentEducation?.courseFees)
                }
                helperText={
                  formik.touched.presentEducation?.courseFees &&
                  formik.errors.presentEducation?.courseFees
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                select
                id="presentEducation.paymentFrequency"
                name="presentEducation.paymentFrequency"
                label="Frequency of Payment *"
                value={formik.values.presentEducation.paymentFrequency}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.paymentFrequency &&
                  Boolean(formik.errors.presentEducation?.paymentFrequency)
                }
                helperText={
                  formik.touched.presentEducation?.paymentFrequency &&
                  formik.errors.presentEducation?.paymentFrequency
                }
                className={styles.textFourField}
              >
                <MenuItem value="">Select Frequency</MenuItem>
                {Frequencies.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                id="presentEducation.totalFeesPaid"
                name="presentEducation.totalFeesPaid"
                label="Total Fees Already Paid *"
                value={formik.values.presentEducation.totalFeesPaid}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.presentEducation?.totalFeesPaid &&
                  Boolean(formik.errors.presentEducation?.totalFeesPaid)
                }
                helperText={
                  formik.touched.presentEducation?.totalFeesPaid &&
                  formik.errors.presentEducation?.totalFeesPaid
                }
                className={styles.textFourField}
              />
            </Box>
          </Box>
        );

      case 3: // Achievements
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Achievements</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={4}>
              Please provide details of any of your achievements. (e.g
              Represented India at international events or secured a state-level
              rank in the board examinations.)
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="achievementsInfo">
                {({ push, remove }) => (
                  <Box>
                    {formik.values.achievementsInfo.map(
                      (Achievement, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              Achievement {index + 1}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box display={"flex"} gap={2}>
                              <Box
                                className={`${styles.fieldRow} ${styles.fieldRowOth} ${styles.fieldRowOthWidth}`}
                              >
                                <TextField
                                  fullWidth
                                  id={`achievementsInfo[${index}].docName`}
                                  name={`achievementsInfo[${index}].docName`}
                                  label="Achievement"
                                  value={Achievement.docName}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.achievementsInfo?.[index]
                                      ?.docName &&
                                    typeof formik.errors.achievementsInfo?.[
                                      index
                                    ] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.achievementsInfo?.[
                                          index
                                        ] as any
                                      )?.docName
                                    )
                                  }
                                  helperText={
                                    formik.touched.achievementsInfo?.[index]
                                      ?.docName &&
                                    typeof formik.errors.achievementsInfo?.[
                                      index
                                    ] !== "string" &&
                                    (
                                      formik.errors.achievementsInfo?.[
                                        index
                                      ] as any
                                    )?.docName
                                  }
                                  className={styles.textNoneField}
                                />
                              </Box>

                              <Box className={styles.fieldRow}>
                                <Box className={styles.fileUploadField}>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ mb: 0 }}
                                    paddingBottom={"0.25rem"}
                                  >
                                    Supporting Document
                                  </Typography>
                                  <Box display={"flex"} alignItems={"center"}>
                                    <Button
                                      variant="contained"
                                      component="label"
                                      className="commonBtn"
                                      sx={{ flex: "none", marginRight: "1rem" }}
                                    >
                                      Choose File
                                      <input
                                        type="file"
                                        hidden
                                        onChange={(e) =>
                                          handleDocumentUpload(e, index)
                                        }
                                      />
                                    </Button>
                                    <Typography variant="body2">
                                      {Achievement.file
                                        ? Achievement.fileName
                                        : "No file chosen"}
                                    </Typography>
                                    {formik.touched.achievementsInfo?.[index]
                                      ?.file &&
                                      typeof formik.errors.achievementsInfo?.[
                                        index
                                      ] !== "string" &&
                                      Boolean(
                                        (
                                          formik.errors.achievementsInfo?.[
                                            index
                                          ] as any
                                        )?.file
                                      ) && (
                                        <Typography
                                          color="error"
                                          variant="caption"
                                        >
                                          {
                                            (
                                              formik.errors.achievementsInfo?.[
                                                index
                                              ] as any
                                            )?.file as string
                                          }
                                        </Typography>
                                      )}
                                  </Box>
                                  {Achievement.fileType ===
                                  "application/pdf" ? (
                                    <>{Achievement.fileName}</>
                                  ) : (
                                    <>
                                      <Box mt={1}>
                                        <img
                                          src={
                                            typeof Achievement.uploadPreview ===
                                            "string"
                                              ? Achievement.uploadPreview
                                              : Achievement.uploadPreview
                                              ? URL.createObjectURL(
                                                  Achievement.uploadPreview
                                                )
                                              : placeholderImg
                                          }
                                          alt="Preview"
                                          style={{
                                            maxHeight: 150,
                                            borderRadius: 8,
                                          }}
                                        />
                                      </Box>
                                    </>
                                  )}
                                  {/* {Achievement.uploadPreview &&
                                    Achievement.file &&
                                    (Achievement.file.type.startsWith(
                                      "image/"
                                    ) ? (
                                      <Box mt={1}>
                                        <img
                                          src={Achievement.uploadPreview}
                                          alt="Preview"
                                          style={{
                                            maxHeight: 150,
                                            borderRadius: 8,
                                          }}
                                        />
                                      </Box>
                                    ) : Achievement.file.type ===
                                      "application/pdf" ? (
                                      <Box mt={1}>
                                        <Typography
                                          variant="body2"
                                          sx={{ fontStyle: "italic" }}
                                        >
                                          PDF preview not available inline.{" "}
                                          <a
                                            href={Achievement.uploadPreview}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Open PDF
                                          </a>
                                        </Typography>
                                      </Box>
                                    ) : null)} */}
                                </Box>
                              </Box>
                            </Box>
                            {formik.values.achievementsInfo.length > 1 && (
                              <Button
                                startIcon={<RemoveCircleOutlineIcon />}
                                color="error"
                                onClick={() => remove(index)}
                                className={styles.removeButton}
                              >
                                Remove
                              </Button>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        startIcon={<AddCircleOutlineIcon />}
                        variant="contained"
                        onClick={() =>
                          push({
                            id: 0,
                            fileName: "",
                            file: "",
                          })
                        }
                        className={styles.commonBtn}
                      >
                        Add More Achievement
                      </Button>
                    </Box>
                    {formik.touched.completedEducation &&
                      typeof formik.errors.completedEducation === "string" && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{ mt: 1 }}
                        >
                          {formik.errors.completedEducation}
                        </Typography>
                      )}
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 4: // Family Details
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={2}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Family Details</span>
            </Typography>
            <Typography variant="body2" align="center" marginBottom={2}>
              Please provide details of your family members.
            </Typography>

            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="familyDetails.fathersName"
                name="familyDetails.fathersName"
                label="Father's Name *"
                value={formik.values.familyDetails.fathersName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.fathersName &&
                  Boolean(formik.errors.familyDetails?.fathersName)
                }
                helperText={
                  formik.touched.familyDetails?.fathersName &&
                  formik.errors.familyDetails?.fathersName
                }
                className={styles.textFourField}
              />

              <TextField
                fullWidth
                id="familyDetails.mothersName"
                name="familyDetails.mothersName"
                label="Mother's Name *"
                value={formik.values.familyDetails.mothersName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.mothersName &&
                  Boolean(formik.errors.familyDetails?.mothersName)
                }
                helperText={
                  formik.touched.familyDetails?.mothersName &&
                  formik.errors.familyDetails?.mothersName
                }
                className={styles.textFourField}
              />

              <TextField
                fullWidth
                id="familyDetails.guardiansName"
                name="familyDetails.guardiansName"
                label="Father’s/Guardian’s Name *"
                value={formik.values.familyDetails.guardiansName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.guardiansName &&
                  Boolean(formik.errors.familyDetails?.guardiansName)
                }
                helperText={
                  formik.touched.familyDetails?.guardiansName &&
                  formik.errors.familyDetails?.guardiansName
                }
                className={styles.textFourField}
              />
            </Box>

            <Box className={styles.fieldRow}>
              <TextField
                fullWidth
                id="familyDetails.fathersOccupation"
                name="familyDetails.fathersOccupation"
                label="Occupation of Father *"
                value={formik.values.familyDetails.fathersOccupation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.fathersOccupation &&
                  Boolean(formik.errors.familyDetails?.fathersOccupation)
                }
                helperText={
                  formik.touched.familyDetails?.fathersOccupation &&
                  formik.errors.familyDetails?.fathersOccupation
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="familyDetails.mothersOccupation"
                name="familyDetails.mothersOccupation"
                label="Occupation of Mother *"
                value={formik.values.familyDetails.mothersOccupation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.mothersOccupation &&
                  Boolean(formik.errors.familyDetails?.mothersOccupation)
                }
                helperText={
                  formik.touched.familyDetails?.mothersOccupation &&
                  formik.errors.familyDetails?.mothersOccupation
                }
                className={styles.textFourField}
              />

              <TextField
                fullWidth
                id="familyDetails.contactNumber"
                name="familyDetails.contactNumber"
                label="Father's/Guardian's Contact No. *"
                value={formik.values.familyDetails.contactNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.contactNumber &&
                  Boolean(formik.errors.familyDetails?.contactNumber)
                }
                helperText={
                  formik.touched.familyDetails?.contactNumber &&
                  formik.errors.familyDetails?.contactNumber
                }
                className={styles.textFourField}
              />
              <TextField
                fullWidth
                id="familyDetails.familyIncome"
                name="familyDetails.familyIncome"
                label="Monthly Family Income *"
                type="number"
                value={formik.values.familyDetails.familyIncome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.familyDetails?.familyIncome &&
                  Boolean(formik.errors.familyDetails?.familyIncome)
                }
                helperText={
                  formik.touched.familyDetails?.familyIncome &&
                  formik.errors.familyDetails?.familyIncome
                }
                className={styles.textFourField}
              />
            </Box>

            <FormikProvider value={formik}>
              <FieldArray name="familyDetails.siblings">
                {({ push, remove }) => (
                  <Box paddingTop={3}>
                    <Typography
                      variant="h6"
                      className={styles.sectionTitle}
                      marginBottom={2}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <span>Siblings Details</span>
                    </Typography>
                    <Typography variant="body2" align="center" marginBottom={2}>
                      Please provide details of your siblings if applicable.
                    </Typography>
                    {formik.values.familyDetails.siblings.map(
                      (sibling, index) => {
                        const isSister =
                          sibling.relationship?.toLowerCase() === "sister";
                        return (
                          <Accordion
                            key={index}
                            defaultExpanded
                            className={styles.accordion}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography
                                variant="subtitle1"
                                className="accrodionHeading"
                              >
                                Siblings {index + 1}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box
                                className={`${styles.fieldRow} ${styles.fieldRowOth}`}
                              >
                                <TextField
                                  fullWidth
                                  id={`familyDetails.siblings[${index}].name`}
                                  name={`familyDetails.siblings[${index}].name`}
                                  label={`Name`}
                                  value={sibling.name}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.name &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.name
                                    )
                                  }
                                  helperText={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.name &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.name
                                  }
                                  className={styles.textFourField}
                                />
                                <TextField
                                  fullWidth
                                  select
                                  id={`familyDetails.siblings[${index}].relationship`}
                                  name={`familyDetails.siblings[${index}].relationship`}
                                  label={`Relationship`}
                                  value={sibling.relationship}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.relationship &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.relationship
                                    )
                                  }
                                  helperText={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.relationship &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.relationship
                                  }
                                  className={styles.textSmallField}
                                >
                                  <MenuItem value="">
                                    Select Relationship
                                  </MenuItem>
                                  <MenuItem value="Brother">Brother</MenuItem>
                                  <MenuItem value="Sister">Sister</MenuItem>
                                </TextField>
                                <TextField
                                  fullWidth
                                  select
                                  id={`familyDetails.siblings[${index}].qualification`}
                                  name={`familyDetails.siblings[${index}].qualification`}
                                  label={`Education Qualification`}
                                  value={sibling.qualification}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.qualification &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    Boolean(
                                      (
                                        formik.errors.familyDetails?.siblings?.[
                                          index
                                        ] as any
                                      )?.qualification
                                    )
                                  }
                                  helperText={
                                    formik.touched.familyDetails?.siblings?.[
                                      index
                                    ]?.qualification &&
                                    typeof formik.errors.familyDetails
                                      ?.siblings?.[index] !== "string" &&
                                    (
                                      formik.errors.familyDetails?.siblings?.[
                                        index
                                      ] as any
                                    )?.qualification
                                  }
                                  className={styles.textFourField}
                                >
                                  {qualificationOptions.map((label) => (
                                    <MenuItem key={label} value={label}>
                                      {label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                {isSister && (
                                  <>
                                    <TextField
                                      fullWidth
                                      id={`familyDetails.siblings[${index}].sisterHusbandName`}
                                      name={`familyDetails.siblings[${index}].sisterHusbandName`}
                                      label={`Husband's Name (if applicable)`}
                                      value={sibling.sisterHusbandName}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandName &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        Boolean(
                                          (
                                            formik.errors.familyDetails
                                              ?.siblings?.[index] as any
                                          )?.sisterHusbandName
                                        )
                                      }
                                      helperText={
                                        formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandName &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        (
                                          formik.errors.familyDetails
                                            ?.siblings?.[index] as any
                                        )?.sisterHusbandName
                                      }
                                      className={styles.textFourField}
                                    />
                                    <TextField
                                      fullWidth
                                      select
                                      id={`familyDetails.siblings[${index}].sisterHusbandOccupation`}
                                      name={`familyDetails.siblings[${index}].sisterHusbandOccupation`}
                                      label={`Husband's Occupation`}
                                      value={sibling.sisterHusbandOccupation}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandOccupation &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        Boolean(
                                          (
                                            formik.errors.familyDetails
                                              ?.siblings?.[index] as any
                                          )?.sisterHusbandOccupation
                                        )
                                      }
                                      helperText={
                                        formik.touched.familyDetails
                                          ?.siblings?.[index]
                                          ?.sisterHusbandOccupation &&
                                        typeof formik.errors.familyDetails
                                          ?.siblings?.[index] !== "string" &&
                                        (
                                          formik.errors.familyDetails
                                            ?.siblings?.[index] as any
                                        )?.sisterHusbandOccupation
                                      }
                                      className={styles.textFourField}
                                    >
                                      {occupationOptions.map((label) => (
                                        <MenuItem key={label} value={label}>
                                          {label}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </>
                                )}

                                {formik.values.familyDetails?.siblings.length >
                                  1 && (
                                  <Button
                                    startIcon={<RemoveCircleOutlineIcon />}
                                    color="error"
                                    onClick={() => remove(index)}
                                    className={styles.removeButton}
                                  >
                                    Remove
                                  </Button>
                                )}
                              </Box>
                            </AccordionDetails>
                            {/* <Divider sx={{ my: 2 }} /> */}
                          </Accordion>
                        );
                      }
                    )}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() =>
                          push({
                            id: 0,
                            name: "",
                            qualification: "",
                            relationship: "",
                          })
                        }
                        className={styles.commonBtn}
                      >
                        Add Another Sibling
                      </Button>
                    </Box>
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 5: // Scholarship Purpose
        return (
          <Box className={styles.formSection}>
            <Typography
              variant="h6"
              className={styles.sectionTitle}
              marginBottom={3}
              display={"flex"}
              justifyContent={"center"}
            >
              <span>Reason for seeking scholarship</span>
            </Typography>
            <Box className={styles.fieldRow} display={"block"}>
              <TextField
                select
                id="scholarshipPurpose.knowApplication"
                name="scholarshipPurpose.knowApplication"
                label="How did you come to know about SRBF Scholarship? *"
                value={formik.values.scholarshipPurpose.knowApplication}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.scholarshipPurpose?.knowApplication &&
                  Boolean(formik.errors.scholarshipPurpose?.knowApplication)
                }
                helperText={
                  formik.touched.scholarshipPurpose?.knowApplication &&
                  formik.errors.scholarshipPurpose?.knowApplication
                }
                className={styles.textAutoField}
              >
                <MenuItem value="">Select Option</MenuItem>
                {KnowApplicationData.map((item, index) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <TextField
              fullWidth
              id="scholarshipPurpose.purposeExplanation"
              name="scholarshipPurpose.purposeExplanation"
              label="Please describe your purpose for applying for this scholarship. *"
              multiline
              rows={6}
              value={formik.values.scholarshipPurpose.purposeExplanation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.scholarshipPurpose?.purposeExplanation &&
                Boolean(formik.errors.scholarshipPurpose?.purposeExplanation)
              }
              helperText={
                formik.touched.scholarshipPurpose?.purposeExplanation &&
                formik.errors.scholarshipPurpose?.purposeExplanation
              }
              className={styles.textField}
            />
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ mb: 1, display: "block" }}
            >
              (Maximum 300 words)
            </Typography>
            <FormikProvider value={formik}>
              <FieldArray name="scholarshipPurpose.otherScholarships">
                {({ push, remove }) => (
                  <Box paddingTop={3}>
                    <Typography
                      variant="h6"
                      className={styles.sectionTitle}
                      marginBottom={3}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <span>Other Scholarships</span>
                    </Typography>
                    <Typography variant="body2" align="center" marginBottom={2}>
                      Please provide details of any other scholarships you are
                      already availing if applicable.
                    </Typography>
                    {formik.values.scholarshipPurpose.otherScholarships.map(
                      (scholarship, index) => {
                        return (
                          <Accordion
                            key={index}
                            defaultExpanded
                            className={styles.accordion}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography
                                variant="subtitle1"
                                className="accrodionHeading"
                              >
                                Scholarships {index + 1}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box className={`${styles.fieldRow}  `}>
                                <TextField
                                  id={`scholarshipPurpose.otherScholarships[${index}].scholarshipsName`}
                                  name={`scholarshipPurpose.otherScholarships[${index}].scholarshipsName`}
                                  label={`Scholarships Name`}
                                  value={scholarship.scholarshipsName}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsName &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    Boolean(
                                      (
                                        formik.errors.scholarshipPurpose
                                          ?.otherScholarships?.[index] as any
                                      )?.scholarshipsName
                                    )
                                  }
                                  helperText={
                                    formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsName &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    (
                                      formik.errors.scholarshipPurpose
                                        ?.otherScholarships?.[index] as any
                                    )?.scholarshipsName
                                  }
                                  className={styles.textFourField}
                                />
                                <TextField
                                  fullWidth
                                  id={`scholarshipPurpose.otherScholarships[${index}].scholarshipsAmount`}
                                  name={`scholarshipPurpose.otherScholarships[${index}].scholarshipsAmount`}
                                  label={`Scholarships Amount`}
                                  type="number"
                                  value={scholarship.scholarshipsAmount}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsAmount &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    Boolean(
                                      (
                                        formik.errors.scholarshipPurpose
                                          ?.otherScholarships?.[index] as any
                                      )?.scholarshipsAmount
                                    )
                                  }
                                  helperText={
                                    formik.touched.scholarshipPurpose
                                      ?.otherScholarships?.[index]
                                      ?.scholarshipsAmount &&
                                    typeof formik.errors.scholarshipPurpose
                                      ?.otherScholarships?.[index] !==
                                      "string" &&
                                    (
                                      formik.errors.scholarshipPurpose
                                        ?.otherScholarships?.[index] as any
                                    )?.scholarshipsAmount
                                  }
                                  className={styles.textFourField}
                                />

                                {formik.values.scholarshipPurpose
                                  ?.otherScholarships.length > 1 && (
                                  <Button
                                    startIcon={<RemoveCircleOutlineIcon />}
                                    color="error"
                                    onClick={() => remove(index)}
                                    className={styles.removeButton}
                                  >
                                    Remove
                                  </Button>
                                )}
                              </Box>
                            </AccordionDetails>
                            {/* <Divider sx={{ my: 2 }} /> */}
                          </Accordion>
                        );
                      }
                    )}
                    <Box
                      padding={2}
                      display={"flex"}
                      justifyContent={"flex-end"}
                    >
                      <Button
                        variant="contained"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() =>
                          push({
                            id: 0,
                            name: "",
                            scholarshipsName: "",
                            scholarshipsAmount: "",
                          })
                        }
                        className={styles.commonBtn}
                      >
                        Add Another Scholarship
                      </Button>
                    </Box>
                  </Box>
                )}
              </FieldArray>
            </FormikProvider>
          </Box>
        );

      case 6: // Bank Details
        return (
          <>
            <Box className={styles.formSection}>
              <Typography
                variant="h6"
                className={styles.sectionTitle}
                marginBottom={3}
                display={"flex"}
                justifyContent={"center"}
              >
                <span>Bank Details</span>
              </Typography>

              <FormikProvider value={formik}>
                <FieldArray name="bankDetails">
                  {({ push, remove }) => (
                    <Box>
                      {formik.values.bankDetails.map((bankItem, index) => (
                        <Accordion
                          key={index}
                          defaultExpanded
                          className={styles.accordion}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography
                              variant="subtitle1"
                              className="accrodionHeading"
                            >
                              {bankItem.bankType}
                              {bankItem.bankType === "New Bank"
                                ? ""
                                : "'s"}{" "}
                              Account
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box className={styles.fieldRow}>
                              <TextField
                                id={`bankDetails[${index}].bankName`}
                                name={`bankDetails[${index}].bankName`}
                                label="Bank Name *"
                                value={bankItem.bankName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.bankName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.bankName
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.bankName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.bankName
                                }
                                className={styles.textAutoField}
                              />
                              <TextField
                                id={`bankDetails[${index}].accountHolderName`}
                                name={`bankDetails[${index}].accountHolderName`}
                                label="Account Holder Name *"
                                value={bankItem.accountHolderName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountHolderName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.accountHolderName
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountHolderName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.accountHolderName
                                }
                                className={styles.textAutoField}
                              />
                              <TextField
                                id={`bankDetails[${index}].accountNumber`}
                                name={`bankDetails[${index}].accountNumber`}
                                label="Account Number *"
                                value={bankItem.accountNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountNumber &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.accountNumber
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.accountNumber &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.accountNumber
                                }
                                className={styles.textAutoField}
                              />
                              <TextField
                                id={`bankDetails[${index}].ifscCode`}
                                name={`bankDetails[${index}].ifscCode`}
                                label="IFSC Code *"
                                value={bankItem.ifscCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.ifscCode &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.ifscCode
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.ifscCode &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.ifscCode
                                }
                                className={styles.textAutoField}
                              />
                              <TextField
                                id={`bankDetails[${index}].branchName`}
                                name={`bankDetails[${index}].branchName`}
                                label="Branch Name *"
                                value={bankItem.branchName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.bankDetails?.[index]
                                    ?.branchName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  Boolean(
                                    (formik.errors.bankDetails?.[index] as any)
                                      ?.branchName
                                  )
                                }
                                helperText={
                                  formik.touched.bankDetails?.[index]
                                    ?.branchName &&
                                  typeof formik.errors.bankDetails?.[index] !==
                                    "string" &&
                                  (formik.errors.bankDetails?.[index] as any)
                                    ?.branchName
                                }
                                className={styles.textAutoField}
                              />
                            </Box>
                            {formik.values.bankDetails.length > 1 && (
                              <Button
                                startIcon={<RemoveCircleOutlineIcon />}
                                color="error"
                                onClick={() => remove(index)}
                                className={styles.removeButton}
                              >
                                Remove
                              </Button>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      ))}
                      <Box
                        padding={2}
                        display={"flex"}
                        justifyContent={"flex-end"}
                      >
                        <Button
                          startIcon={<AddCircleOutlineIcon />}
                          variant="contained"
                          onClick={() =>
                            push({
                              id: 0,
                              bankType: "New Bank",
                              bankName: "",
                              accountHolderName: "",
                              accountNumber: "",
                              ifscCode: "",
                              branchName: "",
                            })
                          }
                          className={styles.commonBtn}
                        >
                          Add More Bank
                        </Button>
                      </Box>
                      {formik.touched.completedEducation &&
                        typeof formik.errors.completedEducation ===
                          "string" && (
                          <Typography
                            color="error"
                            variant="caption"
                            sx={{ mt: 1 }}
                          >
                            {formik.errors.completedEducation}
                          </Typography>
                        )}
                    </Box>
                  )}
                </FieldArray>
              </FormikProvider>
            </Box>
          </>
        );

      default:
        return (
          <Typography variant="h6" sx={{ mt: 2 }}>
            Unknown Step
          </Typography>
        );
    }
  };

  const createApplicationApi = useMutationByMethod<any>(
    "post",
    `${PostUrl.createApplicationDetails}`
  );
  const updateApplicationApi = useMutationByMethod<any>(
    "patch",
    `${PatchUrl.updateApplicationDetails}?is_admin=false`
  );
  const submitApplicationApi = useMutationByMethod<any>(
    "post",
    `${PostUrl.postApplicationSubmit}?application_id=${applicationID}`
  );
  const applicationCreateReq = async () => {
    const appid = localStorage.getItem("applicationID");
    const objValues = formik.values;
    const titleList = [
      "Secondary Education",
      "Higher Secondary Education",
      "Graduation",
      "Post Graduation",
    ];
    const datamap = objValues.completedEducation.map((item, index) => {
      return {
        title: titleList[index] || item.course,
        institution: item.nameSchoolCollege,
        address: item.schoolCollegeAddress,
        university_name: item.nameOfUniversity,
        stream: item.course,
        total_marks_cgpa: item.marksObtainedCGPA,
        year_of_passing: item.yearOfPassing,
        principal_name: item.principalName,
        principal_ph: item.principalContactNumber,
        marksheet_url: item.fileName,
      };
    });
    const datamapSibling = objValues.familyDetails.siblings.map((item) => {
      return {
        sibling_name: item.name,
        relationship: item.relationship,
        occupation: item.qualification,
        sister_husband_name: item.sisterHusbandName,
        sister_husband_occupation: item.sisterHusbandOccupation,
      };
    });
    const datamapother = objValues.scholarshipPurpose.otherScholarships.map(
      (item) => {
        return {
          scholarship_name: item.scholarshipsName,
          scholarship_amount: item.scholarshipsAmount || 0,
        };
      }
    );
    const datamapachievements = objValues.achievementsInfo.map((item) => {
      return {
        achievement: item.docName,
        supporting_doc_url: item.fileName,
      };
    });
    const bankTitleList = ["Student", "Father", "Guardian", "College/School"];
    const banckInfo = objValues.bankDetails.map((item, index) => {
      return {
        title: bankTitleList[index],
        bank_name: item.bankName,
        account_holder_name: item.accountHolderName,
        account_no: item.accountNumber,
        IFSC_no: item.ifscCode,
        branch: item.branchName,
      };
    });

    const obj = {
      application_id: JSON.parse(appid ?? '""'),
      personal_info: {
        first_name: objValues.personalInfo.firstName,
        last_name: objValues.personalInfo.lastName,
        email: objValues.personalInfo.email,
        phone: `${objValues.personalInfo.mobileNumber}`,
        dob: objValues.personalInfo.dateOfBirth,
        home_address: objValues.personalInfo.permanentHomeAddress,
        city: objValues.personalInfo.city,
        zipcode: objValues.personalInfo.zipcode,
        state: objValues.personalInfo.state,
        district: objValues.personalInfo.district,
        photo_url: objValues.personalInfo.profilePhotoName,
        facebook_url: objValues.personalInfo.socialMediaHandleFB,
        instagram_url: objValues.personalInfo.socialMediaHandleInstagram,
        linkedin_url: objValues.personalInfo.socialMediaHandleLinkedIn,
        gender: objValues.personalInfo.gender,
      },
      completedEducation: datamap,
      presentEducation: [
        {
          institution: objValues.presentEducation.nameSchoolorCollege,
          address: objValues.presentEducation.schoolCollegeAddress,
          university_name: objValues.presentEducation.nameOfUniversity,
          stream: objValues.presentEducation.course,
          Year_of_Admission: objValues.presentEducation.yearOfAdmission,
          Current_sem: objValues.presentEducation.currentSemester,
          Course_dur: objValues.presentEducation.courseDuration,
          principal_name: objValues.presentEducation.principalName,
          principal_ph: objValues.presentEducation.principalContactNumber,
          Course_fee: objValues.presentEducation.courseFees,
          Frequency_of_payment: objValues.presentEducation.paymentFrequency,
          Fees_Already_paid: objValues.presentEducation.totalFeesPaid,
        },
      ],
      achievements: datamapachievements,
      family_details: {
        father_name: objValues.familyDetails.fathersName,
        mother_name: objValues.familyDetails.mothersName,
        guardian_name: objValues.familyDetails.guardiansName,
        father_occupation: objValues.familyDetails.fathersOccupation,
        mother_occupation: objValues.familyDetails.mothersOccupation,
        monthly_familiy_income: objValues.familyDetails.familyIncome,
        guardian_ph_number: objValues.familyDetails.contactNumber,
        siblings: datamapSibling,
      },
      scholarship_purpose: {
        source_of_infomation: objValues.scholarshipPurpose.knowApplication,
        scholarship_purpose: objValues.scholarshipPurpose.purposeExplanation,
        other_scholarships: datamapother,
      },
      bank_details: banckInfo,
      // additional_documents: [
      //   {
      //     doc_name: objValues.uploadedDocuments.fileName,
      //     doc_url: objValues.uploadedDocuments.fileName,
      //   },
      // ],
      additional_documents: null,
    };
    console.log("obj", obj);

    setLoading(true);
    createApplicationApi.mutate(obj, {
      onSuccess: (data) => {
        setLoading(false);
        console.log("data new===", data);
        setSuccessModalOpen(true);
        submitApplicationApi.mutate(null, {
          onSuccess: (data) => {
            console.log("data", data);
          },
          onError: (err) => {},
        });
      },
      onError: (err) => {
        setLoading(false);
        console.error("error", err);
        // setSnackbarMessage("Error submitting form. Please try again.");
        // setSnackbarSeverity("error");
        // setSnackbarOpen(true);
        ToastService.error("Error submitting form. Please try again.");
      },
    });
  };

  const shouldFetch = !!applicationID && applicationStatus === "draft";
  const getApplicationData = useGet<any>(
    shouldFetch
      ? `${GetUrl.getApplication}?application_id=${applicationID}`
      : "",
    {},
    shouldFetch
  );
  const fetchApplicationData = async () => {
    showLoader();
    try {
      const result = await getApplicationData.refetch();
      if (result.data) {
        setMainData([result.data]);
        hideLoader();
      }
    } catch (error) {
      console.error("Error fetching app version:", error);
      hideLoader();
    }
  };
  const handleFinalSubmit = () => {
    // You can do additional validation or processing here if needed
    if (shouldFetch) {
      if (Object.keys(deltaPayload).length > 0) {
        updateApplicationApi.mutate(deltaPayload, {
          onSuccess: (data) => {
            setLoading(false);
            hideLoader();
            submitApplicationApi.mutate(null, {
              onSuccess: (data) => {
                console.log("data", data);
                fetchApplicationData();
                setSuccessModalOpen(true);
              },
              onError: (err) => {},
            });
          },
          onError: (err) => {
            setLoading(false);
            console.error("error", err);
            hideLoader();
          },
        });
      } else {
        submitApplicationApi.mutate(null, {
          onSuccess: (data) => {
            console.log("data", data);
            fetchApplicationData();
            setSuccessModalOpen(true);
          },
          onError: (err) => {},
        });
      }
    } else {
      applicationCreateReq();
    }
  };
  useEffect(() => {
    if (appMobileNo) {
      formik.setFieldValue("personalInfo.mobileNumber", appMobileNo);
    }

    console.log("appMobileNo", appMobileNo);
  }, [appMobileNo]);
  useEffect(() => {
    if (shouldFetch) {
      fetchApplicationData();
    } else {
      setMainData([]);
    }
  }, [applicationID, applicationStatus]);

  const applicationUpdateReq = async () => {
    console.log("deltaPayloadassss", deltaPayload);
    if (Object.keys(deltaPayload).length > 0) {
      setLoading(true);
      showLoader();

      if (mainData && isValidPersonalInfo(mainData[0]?.personal_info || {})) {
        updateApplicationApi.mutate(deltaPayload, {
          onSuccess: (data) => {
            setLoading(false);
            hideLoader();
            fetchApplicationData();
            // setSnackbarMessage("Draft saved successfully.");
            // setSnackbarSeverity("success");
            // setSnackbarOpen(true);
            ToastService.success("Draft saved successfully.");
          },
          onError: (err) => {
            setLoading(false);
            console.error("error", err);
            hideLoader();
          },
        });
      } else {
        createApplicationApi.mutate(deltaPayload, {
          onSuccess: (data) => {
            setLoading(false);
            hideLoader();
            fetchApplicationData();
            // setSnackbarMessage("Your saved successfully.");
            // setSnackbarSeverity("success");
            // setSnackbarOpen(true);
            ToastService.success("Your saved successfully.");
          },
          onError: (err) => {
            setLoading(false);
            console.error("error", err);
            hideLoader();
          },
        });
      }
    } else {
      // setSnackbarMessage("No changes");
      // setSnackbarSeverity("success");
      // setSnackbarOpen(true);
      ToastService.warn("Nothing has been modified.");
    }
  };
  useEffect(() => {
    const fulldataLoad = async () => {
      if (mainData) {
        const selectedState = mainData[0]?.personal_info?.state;
        const selectedStateData = RegionArray.states.find(
          (state) => state.name === selectedState
        );
        const titleList = [
          "Secondary Education",
          "Higher Secondary Education",
          "Graduation",
          "Post Graduation",
        ];
        setDistrictOptions(selectedStateData?.districts || []);

        // personalInfo
        formik.setFieldValue(
          "personalInfo.firstName",
          mainData[0]?.personal_info?.first_name
        );
        formik.setFieldValue(
          "personalInfo.lastName",
          mainData[0]?.personal_info?.last_name
        );
        formik.setFieldValue(
          "personalInfo.email",
          mainData[0]?.personal_info?.email
        );

        formik.setFieldValue(
          "personalInfo.state",
          mainData[0]?.personal_info?.state
        );
        formik.setFieldValue(
          "personalInfo.city",
          mainData[0]?.personal_info?.city
        );
        formik.setFieldValue(
          "personalInfo.zipcode",
          mainData[0]?.personal_info?.zipcode
        );
        formik.setFieldValue(
          "personalInfo.mobileNumber",
          mainData[0] && Object.keys(mainData[0]?.personal_info).length > 0
            ? mainData[0]?.personal_info?.phone
            : mainData[0]?.phone_number || appMobileNo
        );
        formik.setFieldValue(
          "personalInfo.dateOfBirth",
          mainData[0]?.personal_info?.dob
        );
        formik.setFieldValue(
          "personalInfo.permanentHomeAddress",
          mainData[0]?.personal_info?.home_address
        );
        formik.setFieldValue(
          "personalInfo.district",
          mainData[0]?.personal_info?.district
        );
        const photoUrl = mainData?.[0]?.personal_info?.photo_url;

        const finalUrl = await getSecureBlobUrl({
          fileName: photoUrl,
          blobBaseUrl: BLOB_API,
          getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
        });

        formik.setFieldValue("personalInfo.profilePhoto", finalUrl);
        formik.setFieldValue("personalInfo.profilePhotoName", photoUrl);
        formik.setFieldValue(
          "personalInfo.socialMediaHandleFB",
          mainData[0]?.personal_info?.facebook_url || ""
        );
        formik.setFieldValue(
          "personalInfo.socialMediaHandleInstagram",
          mainData[0]?.personal_info?.instagram_url || ""
        );
        formik.setFieldValue(
          "personalInfo.socialMediaHandleLinkedIn",
          mainData[0]?.personal_info?.linkedin_url || ""
        );
        formik.setFieldValue(
          "personalInfo.gender",
          mainData[0]?.personal_info?.gender || ""
        );
        if (mainData[0]?.completedEducation.length > 0) {
          formik.setFieldValue(
            "completedEducation",
            mainData[0]?.completedEducation
          );
        }
        const additionalDocs = mainData[0]?.completedEducation || [];
        const uploadedDocPromises = additionalDocs.map(async (item, index) => {
          const secureUrl = await getSecureBlobUrl({
            fileName: item?.marksheet_url,
            blobBaseUrl: BLOB_API,
            getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
          });

          return {
            fileName: item?.marksheet_url,
            secureUrl,
          };
        });
        const resolvedDocs = await Promise.all(uploadedDocPromises);

        mainData[0]?.completedEducation.map((item, index) => {
          return (
            formik.setFieldValue(`completedEducation.[${index}].id`, item.id),
            formik.setFieldValue(
              `completedEducation.[${index}].title`,
              item.title || titleList[index] || "Completed Education"
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].nameSchoolCollege`,
              item.institution
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].schoolCollegeAddress`,
              item.address
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].nameOfUniversity`,
              item.university_name
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].course`,
              item.stream
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].marksObtainedCGPA`,
              item.total_marks_cgpa
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].yearOfPassing`,
              item.year_of_passing
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].principalName`,
              item.principal_name
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].principalContactNumber`,
              item.principal_ph
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].uploadMarksheet`,
              item.marksheet_url
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].fileName`,
              item.marksheet_url
            ),
            formik.setFieldValue(
              `completedEducation.[${index}].uploadMarksheetPreview`,
              resolvedDocs[index].secureUrl
            )
          );
        });

        // presentEducation
        formik.setFieldValue(
          "presentEducation.id",
          mainData[0]?.presentEducation[0]?.id
        );
        formik.setFieldValue(
          "presentEducation.nameSchoolorCollege",
          mainData[0]?.presentEducation[0]?.institution
        );
        formik.setFieldValue(
          "presentEducation.schoolCollegeAddress",
          mainData[0]?.presentEducation[0]?.address
        );
        formik.setFieldValue(
          "presentEducation.nameOfUniversity",
          mainData[0]?.presentEducation[0]?.university_name
        );
        formik.setFieldValue(
          "presentEducation.course",
          mainData[0]?.presentEducation[0]?.stream
        );
        formik.setFieldValue(
          "presentEducation.yearOfAdmission",
          mainData[0]?.presentEducation[0]?.Year_of_Admission
        );
        formik.setFieldValue(
          "presentEducation.currentSemester",
          mainData[0]?.presentEducation[0]?.Current_sem
        );
        formik.setFieldValue(
          "presentEducation.courseDuration",
          mainData[0]?.presentEducation[0]?.Course_dur
        );
        formik.setFieldValue(
          "presentEducation.principalName",
          mainData[0]?.presentEducation[0]?.principal_name
        );
        formik.setFieldValue(
          "presentEducation.principalContactNumber",
          mainData[0]?.presentEducation[0]?.principal_ph
        );
        formik.setFieldValue(
          "presentEducation.courseFees",
          mainData[0]?.presentEducation[0]?.Course_fee
        );
        formik.setFieldValue(
          "presentEducation.paymentFrequency",
          mainData[0]?.presentEducation[0]?.Frequency_of_payment
        );
        formik.setFieldValue(
          "presentEducation.totalFeesPaid",
          mainData[0]?.presentEducation[0]?.Fees_Already_paid
        );
        // achievements:
        if (mainData[0]?.achievements.length > 0) {
          formik.setFieldValue(
            "achievementsInfo",
            mainData[0]?.achievements
          );
        }
        const achievementsDocs = mainData[0]?.achievements || [];
        const achievementsDocPromises = achievementsDocs.map(
          async (item, index) => {
            const secureUrl = await getSecureBlobUrl({
              fileName: item?.supporting_doc_url,
              blobBaseUrl: BLOB_API,
              getTokenUrl: `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}`,
            });

            return {
              fileName: item?.supporting_doc_url,
              secureUrl,
            };
          }
        );
        const resolvedAchievementsDocs = await Promise.all(
          achievementsDocPromises
        );
        mainData[0]?.achievements.map((item, index) => {
          return (
            formik.setFieldValue(`achievementsInfo.[${index}].id`, item.id),
            formik.setFieldValue(
              `achievementsInfo.[${index}].docName`,
              item.achievement
            ),
            formik.setFieldValue(
              `achievementsInfo.[${index}].fileName`,
              item.supporting_doc_url
            ),
            formik.setFieldValue(
              `achievementsInfo.[${index}].uploadPreview`,
              resolvedAchievementsDocs[index].secureUrl
            )
          );
        });

        // family_details: {
        formik.setFieldValue(
          "familyDetails.id",
          mainData[0]?.family_details.id
        );
        formik.setFieldValue(
          "familyDetails.fathersName",
          mainData[0]?.family_details.father_name
        );
        formik.setFieldValue(
          "familyDetails.mothersName",
          mainData[0]?.family_details.mother_name
        );
        formik.setFieldValue(
          "familyDetails.guardiansName",
          mainData[0]?.family_details.guardian_name
        );
        formik.setFieldValue(
          "familyDetails.fathersOccupation",
          mainData[0]?.family_details.father_occupation
        );
        formik.setFieldValue(
          "familyDetails.mothersOccupation",
          mainData[0]?.family_details.mother_occupation
        );
        formik.setFieldValue(
          "familyDetails.familyIncome",
          mainData[0]?.family_details.monthly_familiy_income
        );
        formik.setFieldValue(
          "familyDetails.contactNumber",
          mainData[0]?.family_details.guardian_ph_number
        );
        mainData[0]?.family_details?.siblings?.map((item, index) => {
          return (
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].id`,
              item.id
            ),
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].name`,
              item.sibling_name
            ),
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].relationship`,
              item.relationship
            ),
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].qualification`,
              item.occupation
            ),
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].sisterHusbandName`,
              item.sister_husband_name
            ),
            formik.setFieldValue(
              `familyDetails.siblings.[${index}].sisterHusbandOccupation`,
              item.sister_husband_occupation
            )
          );
        });

        formik.setFieldValue(
          "scholarshipPurpose.knowApplication",
          mainData[0]?.scholarship_purpose.source_of_infomation
        );
        formik.setFieldValue(
          "scholarshipPurpose.purposeExplanation",
          mainData[0]?.scholarship_purpose.scholarship_purpose
        );
        mainData[0]?.scholarship_purpose?.other_scholarships?.map(
          (item, index) => {
            return (
              formik.setFieldValue(
                `scholarshipPurpose.otherScholarships.[${index}].id`,
                item.id
              ),
              formik.setFieldValue(
                `scholarshipPurpose.otherScholarships.[${index}].scholarshipsName`,
                item.scholarship_name
              ),
              formik.setFieldValue(
                `scholarshipPurpose.otherScholarships.[${index}].scholarshipsAmount`,
                item.scholarship_amount
              )
            );
          }
        );
        // bank_details

        if (mainData[0]?.bank_details.length > 0) {
          formik.setFieldValue("bankDetails", mainData[0]?.bank_details);
        }
        mainData[0]?.bank_details?.map((item, index) => {
          return (
            formik.setFieldValue(`bankDetails.[${index}].id`, item.id),
            formik.setFieldValue(`bankDetails.[${index}].bankType`, item.title),
            formik.setFieldValue(
              `bankDetails.[${index}].bankName`,
              item.bank_name
            ),
            formik.setFieldValue(
              `bankDetails.[${index}].accountHolderName`,
              item.account_holder_name
            ),
            formik.setFieldValue(
              `bankDetails.[${index}].accountNumber`,
              item.account_no
            ),
            formik.setFieldValue(
              `bankDetails.[${index}].ifscCode`,
              item.IFSC_no
            ),
            formik.setFieldValue(
              `bankDetails.[${index}].branchName`,
              item.branch
            )
          );
        });

        // mainData[0]?.additional_documents.map((item, index) => {
        //   return formik.setFieldValue(
        //     `uploadedDocuments.fileName`,
        //     item.doc_name
        //   );
        // });
      }
    };
    fulldataLoad();
  }, [mainData]);

  const isValidPersonalInfo = (info: any) => {
    return requiredPersonalInfoFields.every(
      (key) => info[key] !== undefined && info[key] !== null && info[key] !== ""
    );
  };
  const saveDrft = () => {
    localStorage.setItem("scholarshipDraft", JSON.stringify(formik.values));
    setDraftStateUpdate(true);
    applicationUpdateReq();
  };

  return (
    <Container className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h5" className={styles.title}>
          Scholarship Application Form
        </Typography>
        <Box className={styles.navigationButtons}>
          <Button
            variant="contained"
            className={styles.draftButton}
            onClick={() => {
              saveDrft();
            }}
          >
            Save Draft
          </Button>
          <Button
            variant="text"
            startIcon={<ChevronLeftIcon />}
            className={styles.navButton}
            onClick={handleBack}
            disabled={activeStep === 0}
          >
            Previous
          </Button>
          <Button
            variant="text"
            endIcon={<ChevronRightIcon />}
            className={styles.navButton}
            onClick={handleNext}
            disabled={activeStep === steps.length - 1}
          >
            Next
          </Button>
          <Button
            variant="contained"
            className={styles.saveButton}
            onClick={() => formik.handleSubmit()} // This will submit the current step's data
          >
            Submit
          </Button>
        </Box>
      </Box>

      <Stepper
        activeStep={activeStep}
        className={styles.stepper}
        alternativeLabel={!isMobile}
        orientation={isMobile ? "vertical" : "horizontal"}
        connector={<CustomConnector />}
      >
        {steps.map((label, index) => (
          <Step
            key={label}
            onClick={() => setActiveStep(index)}
            style={{ cursor: "pointer" }}
          >
            <StepLabel
              StepIconComponent={CustomStepIcon}
              className={
                `${styles.steperLabelText} ` +
                (index === activeStep ? styles.activeStepLabel : "")
              }
            >
              <span className={styles.textSpan}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingBottom={2}
      >
        {/* <Box>
          <Typography display={'flex'} alignItems={'center'}>Scholarship ID: <Typography fontWeight={'bold'}>SRBF2022/01</Typography></Typography>
        </Box> */}
        <Box p={0} display={"flex"} alignItems={"center"}>
          <Typography>Application ID: </Typography>
          <Typography fontWeight={"bold"}>{applicationID}</Typography>
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 3 }} />
      <form onSubmit={handleSubmit(onSubmit)} className="form-group">
        {getStepContent(activeStep)}
      </form>

      <Dialog open={successModalOpen} onClose={handleSuccessModalClose}>
        <DialogTitle className={styles.dialogTitle}>
          Application Submitted Successfully
        </DialogTitle>
        <DialogContent>
          <Typography className={styles.textOne}>
            Your Application ID:<strong> {applicationID}</strong>
          </Typography>
          <DialogContentText className={styles.dialogContentText}>
            You can check the status of your application in the{" "}
            <strong>Application Status</strong> section using the above
            Application ID.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "1rem",
          }}
        >
          <Button
            onClick={() => {
              // Print only the application summary (success modal content)
              const printContents = document.querySelector(
                `.${styles.dialogTitle}`
              )?.parentElement?.innerHTML;
              const printWindow = window.open("", "", "height=600,width=800");
              if (printWindow && printContents) {
                printWindow.document.write(
                  "<html><head><title>Application Submitted</title>"
                );
                // Optionally add some minimal styling for print
                printWindow.document.write(
                  "<style>body{font-family:sans-serif;padding:2rem;} strong{font-weight:bold;}</style>"
                );
                printWindow.document.write("</head><body>");
                printWindow.document.write(printContents);
                printWindow.document.write("</body></html>");
                printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                  printWindow.print();
                  printWindow.close();
                }, 500);
              }
            }}
            variant="contained"
            autoFocus
            className={styles.commonButtonTwo}
          >
            Print
          </Button>
          <Button
            onClick={handleSuccessModalClose}
            variant="contained"
            autoFocus
            className={styles.commonButton}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar> */}
    </Container>
  );
};

export default ScholarshipApplicationCreate;
